module.exports = __webpack_public_path__ + "img/SAHAL.b5ca6055.png";